import {HStack, Stack} from "@chakra-ui/react";
import {Button} from "../../../ui/button";
import {memo} from "react";
import {ResetFunction} from "../../../../hooks/table";
import T from "platformed-components/i18n/T";

export const BottomBar = memo(({reset}: {reset: ResetFunction}) => {
  return (
    <Stack p={2}>
      <HStack justifyContent="flex-end">
        <Button size="2xs" variant="ghost" colorPalette="red" onClick={reset}>
          <T keyName="c.Reset" />
        </Button>
      </HStack>
    </Stack>
  );
});
